module.exports = new __parcel__URL__("generic-error.0988ff98.svg").toString();